import { defineComponent, h } from '@vue/composition-api';
import { withInstall } from '../util/index.js';
import useLazyRender from '../util/useLazyRender.js';

var Overlay = defineComponent({
  name: 'm-overlay',
  props: {
    visible: {
      type: Boolean,
      "default": false
    },
    zIndex: {
      type: [Number, String],
      "default": 100
    },
    duration: {
      type: [Number, String],
      "default": 300
    },
    // 是否锁定背景滚动
    lockScroll: {
      type: Boolean,
      "default": false
    },
    className: {
      type: String,
      "default": ''
    }
  },
  slots: ['default'],
  setup: function setup(props, context) {
    var lazyRrender = useLazyRender(function () {
      return props.visible;
    });
    return function () {
      return h("transition", {
        "attrs": {
          "name": 'm-ani-fade',
          "appear": true
        }
      }, [lazyRrender(function () {
        var _context$slots$defaul, _context$slots;

        return h("div", {
          "class": "m-mask ".concat(props.className),
          "directives": [{
            name: "show",
            value: props.visible
          }],
          "style": {
            zIndex: props.zIndex,
            transitionDuration: "".concat(props.duration, "ms"),
            position: 'fixed'
          },
          "on": {
            "touchmove": function touchmove(e) {
              return props.lockScroll && e.preventDefault();
            }
          }
        }, [(_context$slots$defaul = (_context$slots = context.slots)["default"]) === null || _context$slots$defaul === void 0 ? void 0 : _context$slots$defaul.call(_context$slots)]);
      })]);
    };
  }
});
withInstall(Overlay);

export { Overlay as default };
//# sourceMappingURL=index.js.map
